"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMention = exports.isCustomElement = void 0;
const types_1 = require("../types");
const isCustomElement = (element) => Boolean(element && typeof element === 'object' && 'type' in element);
exports.isCustomElement = isCustomElement;
const isMention = (element) => (0, exports.isCustomElement)(element) && element.type === types_1.SlateElementType.mention;
exports.isMention = isMention;
